<template>
    <div class="ntab">
        <ul class="n-flex n-scroll-x">
            <li
                v-for="item in tabOptions"
                class="n-mr-4"
                :key="item.dictKey">
                <nbutton
                    size="small"
                    :type="active == item.dictKey ? 'primary' : 'secondary'"
                    @click="goToHome(item.dictKey)">
                    {{ item.dictValue }}
                </nbutton>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
// 定义props
defineProps<{
    active: string;
    tabOptions: {
        dictKey: string;
        dictValue: string;
    }[];
}>();

// 定义emits用于v-model
const emit = defineEmits<{
    'update:active': [value: string];
}>();

// 定义goToHome方法
const goToHome = (dictKey: string) => {
    emit('update:active', dictKey);
};
</script>
